import { Component, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";

import { SearchResult } from "../services/consultation.service";
import {
    SearchResultsUpdate,
    SearchFormComponent,
} from "./search-form.component";
import { SearchResultsComponent } from "./search-results.component";
import { zbdGlobals } from "../../globals";
import { NotificationService } from "../services/notification.service";
import { RootState } from "../store/root";
import { ResetStore } from "../store/reset-meta";
import { ZipDownloadComponent } from "../components/modals/zip-download.component";
import { UserInfo } from "../data/product";
import { KeycloakService } from "../security";

@Component({
    selector: "zbd-search",
    templateUrl: "search.component.html",
    styleUrls: ["search.component.css"],
})
export class SearchComponent implements OnInit {
    @ViewChild(SearchFormComponent) searchFormComponent: SearchFormComponent;
    @ViewChild(SearchResultsComponent)
    searchResultsComponent: SearchResultsComponent;
    @ViewChild(ZipDownloadComponent) zipDownloadModal: ZipDownloadComponent;

    searchResults: SearchResult[];
    nextResultsPage: number;
    moreResults: boolean;
    searching: boolean;

    buildVersion = version.BUILD_VERSION;
    zbdGlobals = zbdGlobals;

    constructor(
        private store: Store<RootState>,
        private notify: NotificationService,
        private keycloak: KeycloakService,
    ) {
        this.store.dispatch(new ResetStore());
    }

    ngOnInit(): void {
        this.searchResults = [];
    }

    onSearchResultsUpdate(update: SearchResultsUpdate): void {
        this.searching = false;
        if (update.page == undefined || update.page == null) {
            if (update.results !== undefined && update.results !== null) {
                this.searchResults = update.results;
                this.nextResultsPage = 1;
                this.moreResults = true;
            } else {
                this.searchResults = [];
                this.nextResultsPage = 0;
                this.moreResults = false;
            }
        } else {
            this.searchResults = this.searchResults.concat(update.results);
            this.nextResultsPage += 1;
            this.moreResults = true;
        }
    }

    onSearchFailed(error: any): void {
        this.searching = false;
        this.notify.errorExt("Suche", "Die Suche ist fehlgeschlagen.", error);
    }

    onCreateFailed(error: any): void {
        this.notify.errorExt(
            "Neuer Vorgang",
            "Es konnte kein neuer Vorgang angelegt werden.",
            error,
        );
    }

    onSearchMore(): void {
        this.searching = true;
        this.searchFormComponent.search(this.nextResultsPage);
    }

    showDownloadOption() {
        const userInfo = new UserInfo(this.keycloak.getExistingParsedToken());
        return !this.zbdGlobals.embedded && !userInfo.isDa();
    }
}
